import { atom } from 'recoil';

import type { TMyAudioTabItemType } from '~/pages/MyAudioPage/types';

export const selectedTab = atom<TMyAudioTabItemType>({
  default: 'recents',
  key: 'selectedTab',
});
